<template>
  <div class="cart">
    <div class="cart__title">Корзина</div>
    <div class="cart__header">
      <div class="cart__header-text">К заказу {{ basket.length }} товаров</div>
      <button class="cart__header-btn" @click="onClear">Очистить</button>
    </div>
    <div class="cart__list">
      <CartItem v-for="(item, idx) in basket" :data="item" @onClear="onClear" :key="idx" />
    </div>
    <div class="field">
      <Input
        type="text"
        placeholder="Комментарий"
        v-model="model.comment"
      />
    </div>
    <div class="field">
      <Input type="text" placeholder="Интервал доставки" v-model="model.time" />
    </div>
    <div class="cart__bottom">
      <div class="cart__result">{{ priceFormat(resultPrice) }}</div>
      <button class="cart__btn btn btn--green" @click="onOpenResult">
        Оформить
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { computed, onMounted, onUnmounted, ref } from "vue";
  import CartItem from "./CartItem.vue";
  import Input from "@/UI/Input.vue";
  import { priceFormat } from "@/helpers/priceFormat";
  import { eventBus } from "@/helpers/eventBus";
import { IProduct } from "@/models/models";

  const emit = defineEmits(["onOpenResult", "onCloseDetail"]);

  const onOpenResult = () => {
    emit("onOpenResult");
  };

  const basket = ref<Array<IProduct>>(JSON.parse(localStorage.getItem("basket") || "[]"));

  const onClear = () => {
    basket.value = [];

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-clear", {});

    emit("onCloseDetail");
  };

  const model = ref({
    comment: "",
    time: "В течении двух суток",
  });

  const resultPrice = computed(() => {
    let sum = 0;

    basket.value.forEach((item) => {
      sum += item.count * item.basePrice;
    });

    return sum;
  });

  const updateCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    
    if (basket.value.length == 0) {
      emit("onCloseDetail");
    }
  };

  onMounted(() => {
    updateCart();
    eventBus.on("cart-updated", updateCart);
  });

  onUnmounted(() => {
    eventBus.off("cart-updated", updateCart);
  });
</script>
<style scoped lang="scss">
  .cart {
    padding: 20px 24px;

    &__title {
      font-size: 26px;
      line-height: 28px;
      font-weight: 700;
      color: $almostBlack;
      margin-bottom: 20px;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;

      &-text {
        font-size: 14px;
        line-height: 16px;
        color: $darkGray;
      }

      &-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        line-height: 16px;
        color: $darkGray;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 20px;
      margin-bottom: 20px;
    }

    &__bottom {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 10px;
      margin-top: 20px;
    }

    &__result {
      font-size: 26px;
      line-height: 38px;
      font-weight: 700;
      color: $darkGreen;
    }

    &__btn {
      width: fit-content;
      padding: 11px 40px;
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
